import { getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing('m')};
`;
